import React from 'react';

const FastGripLogo = ({ className = '', size = 'md' }) => {
  const sizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
  };

  return (
    <span
      className={`inline-flex items-center font-black italic tracking-tight text-primary ${sizes[size] || sizes.md} ${className}`}
      style={{ fontFamily: "'Inter', sans-serif" }}
      data-testid="fastgrip-logo"
    >
      <span className="mr-0.5">&#9889;</span>
      <span style={{ fontStyle: 'italic', fontWeight: 900 }}>FASTGRIP</span>
    </span>
  );
};

export default FastGripLogo;
